// check that all states are getting cleared on completion & that it works if you decide not to upload telemetry.

// need a warning if you try and start the process with the same event,run,racer and either reject it or allow to overwrite existing DB items. Not sure what that does to the HLS files.

import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';

import { prepareAndUploadTelemetry } from './telemetryFilePrep';
import SessionDetails from './SessionDetails';
import AttachTelemetry from './AttachTelemetry';
import VideoSelection from './VideoSelection';
import { Copyright } from './Copyright';

import { Storage, API } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { GlobalContext } from '../GlobalState';
import { createVideoData as createVideoMutation } from '../../graphql/mutations';
import { updateVideoData as updateVideoMutation } from '../../graphql/mutations';
import { listVideoData as listVideoMutation } from '../../graphql/queries';

const steps = ['Session Details', 'Attach Telemetry', 'Video Selection'];

const DRYRUN = false;

export default function SessionUpload({
  liftCreatingSession,
  liftVidUploadProgressPercent,
}) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [isRaceHeroEvent, setIsRaceHeroEvent] = React.useState(true);
  const [isTelemetryUpload, setIsTelemetryUpload] = React.useState(true);
  const [selectedRunDetails, setSelectedRunDetails] = React.useState({});
  const [telemetryFileMetaData, setTelemetryFileMetaData] = React.useState({
    Format: '',
    Venue: '',
    Vehicle: '',
    User: '',
    Date: '',
    Time: '',
    SampleRate: 0,
    Duration: 0,
    Segment: '',
    BeaconMarkers: [],
    SegmentTimes: [],
  });
  const [telemetryDataArray, setTelemetryDataArray] = React.useState([]); //kpw
  const [telemetryUploadStatus, setTelemetryUploadStatus] = React.useState(0); // 0; nothing, 1; processing; 2; uploading, 3; complete
  const [telemetryS3Key, setTelemetryS3Key] = React.useState();

  const { activeProfile } = React.useContext(GlobalContext);
  const { user } = useAuthenticator((context) => [context.user]);

  const [videoFileDetails, setVideoFileDetails] = React.useState({});
  const [videoYoutubeUrl, setVideoYoutubeUrl] = React.useState(null);
  const [videoMarkers, setVideoMarkers] = React.useState({
    greenFlagTime: 0,
    startLineTime: 0,
    vidDuration: 0,
    cameraAngle: 'front', //temp
  });
  const [uploadVideoFlag, setUploadVideoFlag] = React.useState(true);

  // kpw - need to adjust this to do one thing for youtube, another for file
  function formatVideoDbUpdateData() {
    const submittedFileName = videoFileDetails?.filename || null; // same as videoFileDetails.filename
    const fileExtension = submittedFileName?.split('.').pop(); // grab the file extension
    const standardizedFileName =
      `${selectedRunDetails.eventId}_${selectedRunDetails.runId}_${selectedRunDetails.racerId}_${videoMarkers.cameraAngle}_${user.username}_video.${fileExtension}` ||
      null;
    // we can wait for the telemetry S3 upload to return a key, or we can just use the filename we submitted as key.
    // i should fix since i have it defined in tow places in this file.
    const handmadeS3TelemetryKey =
      telemetryDataArray?.length > 0 //kpw
        ? `${selectedRunDetails.eventId}_${selectedRunDetails.runId}_${selectedRunDetails.racerId}_${user.username}_telemetry.json`
        : null;
    const videoData = {
      username: user.username,
      cameraAngle: videoMarkers.cameraAngle,
      greenFlag: videoMarkers.greenFlagTime,
      crossStart: videoMarkers.startLineTime,
      sccaid: activeProfile.sccaid,
      eventId: selectedRunDetails.eventId,
      runId: selectedRunDetails.runId,
      carNum: selectedRunDetails.racerId,
      srcVideoFormattedName: videoYoutubeUrl ? null : standardizedFileName,
      vidSource: videoYoutubeUrl ? null : submittedFileName,
      telemetryS3Key: handmadeS3TelemetryKey,
      vidUploadInitiated: false,
      tempLocalVideoLink: videoYoutubeUrl ? null : videoFileDetails.fileurl,
      youtubeStreamUrl: videoYoutubeUrl,
      groups: activeProfile.memberOf,
    };
    return videoData;
  }

  const createVideoRecord = async () => {
    const data = formatVideoDbUpdateData();
    console.log(data);
    if (DRYRUN === true) {
      console.log('dryrun Video DB update');
      return;
    }
    try {
      const videoResponse = await API.graphql({
        query: createVideoMutation,
        variables: { input: data },
      });
      console.log(videoResponse.data.createVideoData);
    } catch (error) {
      console.log(error);
    }
  };

  function liftTelemetryDataArray(t) {
    setTelemetryDataArray(t);
  }

  function liftTelemetryFileMetaData(m) {
    setTelemetryFileMetaData(m);
  }

  function setHeroState(state) {
    setIsRaceHeroEvent(state);
  }

  function setTelemetryUpload(state) {
    setIsTelemetryUpload(state);
  }

  function liftSelectedRunDetails(o) {
    setSelectedRunDetails(o);
  }

  function liftVideoFileDetails(file) {
    console.log(file);
    if (file) {
      const fileInfo = {
        file: file,
        fileurl: URL.createObjectURL(file),
        filename: file.name,
        filetype: file.type,
        filesize: file.size,
        filelastmodifieddate: new Date(file.lastModified),
      };
      setVideoFileDetails(() => fileInfo);
    } else setVideoFileDetails(() => {});
  }

  function liftVideoMarkers(m) {
    setVideoMarkers(m);
  }

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      console.log(
        'final step... process and upload the finalized telemetry file and write the DB entries'
      );
      // telemetry upload
      if (telemetryFileMetaData?.Duration > 0) {
        console.log('uploading telemetry');
        setTelemetryUploadStatus(1);
        const preparedTelemetryFile = prepareAndUploadTelemetry(
          telemetryFileMetaData,
          telemetryDataArray,
          selectedRunDetails
        );
        setTelemetryUploadStatus(2);
        uploadTelemetryToS3(preparedTelemetryFile);
        setTelemetryUploadStatus(22);
      } else {
        console.log('no telemetry to upload');
      }
      // update DB record.
      createVideoRecord();
    }
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleCancel = () => {
    // will need to clear all the states
    liftCreatingSession(false);
  };

  const uploadTelemetryToS3 = async (final_file) => {
    const d = selectedRunDetails;
    const filename = `${d.eventId}_${d.runId}_${d.racerId}_${user.username}_telemetry.json`;
    try {
      // Upload file to S3
      const result = await Storage.put(filename, final_file, {
        level: 'public', //public, protected, private - Amplify makes me crazy.
      });
      console.log('File uploaded successfully:', result);
      setTelemetryUploadStatus(4);
      setTelemetryS3Key(result?.key);
    } catch (error) {
      console.error('Error uploading file:', error);
      // Handle error
    }
    // Reset states after upload
  };

  function finalUploadAndReview() {
    if (uploadVideoFlag === true) {
      async function handleSubmitVideo() {
        // setUploadInterrupted(false);
        const data = formatVideoDbUpdateData();
        console.log(data.srcVideoFormattedName);
        await Storage.put(data.srcVideoFormattedName, videoFileDetails.file, {
          resumable: true, //this causes a 403 from S3 - see https://stackoverflow.com/questions/47738508/aws-s3-upload-403-error-when-attempting-multipart-upload
          level: 'public',
          bucket: 'hellatightvidpipeline-source-ms1w4qbgasx2',
          customPrefix: { public: '' },
          // contentType: 'image/png', // when done, limit this to video files,
          completeCallback: (event) => {
            console.log(`Successfully uploaded ${event}`);
            console.log('clearing form states');
            // clearVidStates();
          },
          progressCallback: (progress) => {
            console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
            liftVidUploadProgressPercent(progress.loaded / progress.total);
          },
          errorCallback: (err) => {
            if (liftVidUploadProgressPercent((p) => p < 1)) {
              console.error('Not done uploading.  Lets resume.', err);
              // setUploadInterrupted(true);
            }
            console.error('Unexpected error while uploading', err);
          },
        });
        // update the db with vidUploadInitiated
        const s = selectedRunDetails;
        findAndUpdateVidRecord(s.eventId, s.runId, s.racerId);
      }
      handleSubmitVideo();
    }
    // return to view page
    liftCreatingSession(false);
  }

  async function findVideoEntry(event_id, run_id, driver_id) {
    const variables = {
      filter: {
        and: [
          { eventId: { eq: event_id } },
          { runId: { eq: run_id } },
          { carNum: { eq: driver_id } },
        ],
      },
    };
    try {
      const result = await API.graphql({
        query: listVideoMutation,
        variables: variables,
      });
      const data = result?.data?.listVideoData?.items[0];
      if (data) return data;
    } catch (error) {
      console.log(error);
    }
  }

  async function updateVideoEntry(vid_record_obj) {
    const videoUpdates = {
      id: vid_record_obj.id,
      _version: vid_record_obj._version,
      vidUploadInitiated: true,
    };
    console.log(videoUpdates);
    try {
      const updatedVidRecord = await API.graphql({
        query: updateVideoMutation,
        variables: { input: videoUpdates },
      });
      // console.log(updatedVidRecord);
      return updatedVidRecord;
    } catch (error) {
      console.log(error);
    }
  }

  async function findAndUpdateVidRecord(event, run, driver) {
    const find = await findVideoEntry(event, run, driver);
    console.log(find);
    const update = await updateVideoEntry(find);
    console.log(update);
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <SessionDetails
            setHeroState={setHeroState}
            isRaceHeroEvent={isRaceHeroEvent}
            liftSelectedRunDetails={liftSelectedRunDetails}
            selectedRunDetails={selectedRunDetails}
          />
        );
      case 1:
        return (
          <AttachTelemetry
            setTelemetryUpload={setTelemetryUpload}
            isTelemetryUpload={isTelemetryUpload}
            selectedRunDetails={selectedRunDetails}
            telemetryFileMetaData={telemetryFileMetaData}
            liftTelemetryFileMetaData={liftTelemetryFileMetaData}
            telemetryDataArray={telemetryDataArray}
            liftTelemetryDataArray={liftTelemetryDataArray}
          />
        );
      case 2:
        return (
          <VideoSelection
            liftVideoFileDetails={liftVideoFileDetails}
            videoFileDetails={videoFileDetails}
            liftVideoMarkers={liftVideoMarkers}
            videoMarkers={videoMarkers}
            setVideoYoutubeUrl={setVideoYoutubeUrl}
            videoYoutubeUrl={videoYoutubeUrl}
          />
        );
      default:
        throw new Error('Unknown step');
    }
  }

  const ContinueButton = () => {
    // const label = activeStep === steps.length - 1 ? 'Save Session' : 'Next';
    let label2 = 'blank';
    // console.log(activeStep);
    if (
      activeStep === 1 &&
      (!telemetryDataArray || telemetryDataArray?.length === 0)
    ) {
      label2 = 'Skip';
    } else if (activeStep === steps.length - 1) {
      label2 = 'Save Session';
    } else {
      label2 = 'Next';
    }
    return (
      <Button variant="contained" onClick={handleNext} sx={{ mt: 3, ml: 1 }}>
        {label2}
      </Button>
    );
  };

  return (
    <React.Fragment>
      {/* <CssBaseline /> */}
      <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <Typography component="h1" variant="h4" align="center">
            Session Upload
          </Typography>
          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              {!videoYoutubeUrl ? (
                <React.Fragment>
                  <Typography variant="h5" gutterBottom>
                    Your session is ready to review!
                  </Typography>
                  <Typography variant="subtitle1">
                    You can review your session locally until you close your
                    brower. After closing the browser you will need to re-select
                    the same video file and either review or upload.
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch defaultChecked />}
                      label="Upload Video Now"
                      onChange={() => setUploadVideoFlag(!uploadVideoFlag)}
                    />
                    <Button variant="contained" onClick={finalUploadAndReview}>
                      {uploadVideoFlag
                        ? 'Upload and Review Video'
                        : 'Review Video'}
                    </Button>
                  </FormGroup>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography variant="h5" gutterBottom>
                    Your session is ready to review!
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => liftCreatingSession(false)}
                  >
                    Review Video
                  </Button>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {getStepContent(activeStep)}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={handleCancel} sx={{ mt: 3, ml: 1 }}>
                  Cancel
                </Button>
                {activeStep !== 0 && (
                  <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                    Back
                  </Button>
                )}
                <ContinueButton />
                {/* <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{ mt: 3, ml: 1 }}
                >
                  {activeStep === steps.length - 1 ? 'Save Session' : 'Next'}
                </Button> */}
              </Box>
            </React.Fragment>
          )}
        </Paper>
        <Copyright />
      </Container>
    </React.Fragment>
  );
}
